import { toast, Flip } from 'react-toastify';

const PopupMessage = (msg, error) => {
  // eslint-disable-next-line no-unused-expressions
  error
    ? toast.error(msg, { transition: Flip, autoClose: 3000 })
    : toast.success(msg, { transition: Flip, autoClose: 3000 });
};
export default PopupMessage;
